import clsx from 'clsx'
import React, { Dispatch, FC, MutableRefObject, SetStateAction } from 'react'

import styles from './HorizontalCarouselProgressBar.module.scss'

export interface HorizontalCarouselProgressBarProps {
  carouselRef: MutableRefObject<HTMLDivElement | null>
  halfSizeProgressBar: boolean
  onPercentageChange: (percent: number) => void
  percentage: number
  progressClassName?: string
  setActive: Dispatch<SetStateAction<boolean>>
}

export const HorizontalCarouselProgressBar: FC<HorizontalCarouselProgressBarProps> = ({
  carouselRef,
  halfSizeProgressBar,
  onPercentageChange,
  percentage,
  progressClassName,
  setActive,
}) => {
  const handlePercentageChange = (value) => {
    setActive(true)
    const newPercentage = parseFloat(value)
    onPercentageChange(newPercentage)
    const element = carouselRef.current
    if (element) {
      const scrollWidth = element.scrollWidth - element.clientWidth
      const newScrollLeft = (scrollWidth * newPercentage) / 100
      element.scrollLeft = newScrollLeft
    }
  }

  return (
    <div className={clsx(styles.horizontalCarouselProgressBar)}>
      <input
        className={clsx(styles.carousel, halfSizeProgressBar && styles.half, progressClassName)}
        max="100"
        min="0"
        onChange={event => handlePercentageChange(event.target.value)}
        onMouseUp={() => setActive(false)}
        type="range"
        value={percentage}
      />
    </div>
  )
}
